export function getCollectionResourceKey(resourceType: string, resourceId: unknown): string {
  return `${resourceType}:${String(resourceId)}`
}
